import {FC} from 'react'
import {ROUTE_MAP_AUTH} from './auth'
import {ROUTE_MAP_DROPBOX} from './dropbox'
import {RouteParamEmpty, RouteParam} from './RouteParam'

export type RoutePermission = 'guest' | 'user' | 'all'

type CompleteRouteMapEntry = {
  path: string
  component: FC<any>
  disabled?: boolean
  exact?: boolean
  permission?: RoutePermission
}

type DefaultState<T> = {
  defaultState: T | null
}

export type RouteMapEntry<T, K extends keyof T> = T[K] extends RouteParamEmpty
  ? CompleteRouteMapEntry
  : CompleteRouteMapEntry & DefaultState<T[K]>

export type RouteMap<T> = {
  [K in keyof T]: RouteMapEntry<T, K>
}

export const ROUTE_MAP: RouteMap<RouteParam> = {
  ...ROUTE_MAP_AUTH,
  ...ROUTE_MAP_DROPBOX,
}
